var render, staticRenderFns
import script from "./DragMixin.vue?vue&type=script&lang=ts&"
export * from "./DragMixin.vue?vue&type=script&lang=ts&"
import style0 from "./DragMixin.vue?vue&type=style&index=0&id=6d64b859&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d64b859",
  null
  
)

export default component.exports